import * as React from "react";
interface EmailLinkProps extends React.HTMLProps<HTMLElement> {
    emailAddress: string;
    label?: string;
}
const EmailLink: React.FC<EmailLinkProps> = (props: EmailLinkProps) => {
    if (props.emailAddress) {
        const href = "mailto:" + props.emailAddress;
        return (<a href={href} aria-label={props.emailAddress}>
                {props.label || props.emailAddress}
            </a>);
    }
    else {
        return null;
    }
};
EmailLink.displayName = "EmailLink"
export default EmailLink;
